import React, { useState } from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import get from 'lodash/get';

import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import Container from '../../../components/molecules/Container';
import Overlay from '../../../components/atoms/Overlay';
import Box from '../../../components/molecules/Box';
import { COMPONENT_NAME } from './locators';
import Grid from '../../../components/molecules/Grid';
import useStyles from './style';
import Typography from '../../../components/atoms/Typography';
import Picture from '../../../components/atoms/Picture';
import Button from '../../../components/atoms/Button';
import Link from '../../../components/atoms/Link';
import aspectRatios from '../../../utils/AspectRatios';
import { getThumbnailFromYoutube, plyrVideo } from '../../../utils/video';
import { isInsideChina } from '../../../utils/cookie';
import { decodeHTML } from '../../../utils/decodeHTML';
import { canUseDOM } from '../../../utils/canUseDOM';
import { useMediaQuery } from '@material-ui/core';
import { breakpoints } from '../../../../styles/themes/vad/constants';

import {
  pushAnaylyticsData,
  createDynamicLabels,
} from '../../../../utils/analytics';
import {
  getPageName,
  getComponentName,
} from '../../../utils/getPageComponentInfo';
import { analyticsData } from '../../../../constants/Analytics/analytics-data';
import CustomVideo from '../../../components/atoms/Video';
import YoukuPlayer from '../../../components/molecules/YoukuPlayer';
import clsx from 'clsx';

const FlexiVisual = props => {
  const [isOverlayVisible, setVisibleState] = useState(false);
  const isMobile = useMediaQuery(`(max-width:${breakpoints.values.lg}px)`);
  const google360IframeSrc = get(
    props,
    'fields.flexiVisualIframe.value.href',
    ''
  );
  const flexiVisualComponentHeading = get(
    props,
    'fields.flexiVisualComponentHeading',
    ''
  );
  const flexiVisualTitle = get(props, 'fields.flexiVisualTitle', '');
  const flexiVisualIconType = get(
    props,
    'fields.flexiVisualIconType.fields.icon',
    ''
  );
  const flexiVisualSubText = get(props, 'fields.flexiVisualSubText', '');
  const flexiVisualCtaText = get(props, 'fields.flexiVisualCtaText.value', '');
  const flexiVisualImage = get(props, 'fields.flexiVisualImage', '');
  let flexiVisualCta = get(props, 'fields.flexiVisualCta', '');
  const flexiVisualVideoYoutube = get(
    props,
    'fields.flexiVisualVideoYoutube',
    ''
  );
  const flexiVisualVideoYouku = get(props, 'fields.flexiVisualVideoYouku', '');
  const location = get(props, 'fields.location', '');
  const SEOEnglishCTA = get(props, 'fields.SEOEnglishCTA');
  const componentName = getComponentName(props);
  const isFlexVisual = componentName === 'FlexiVisual';

  const desktopImageWithFallBackFeature = {
    value: {
      src:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAGCAQAAABgddZsAAAAD0lEQVR42mNkIAAYh4ICAAN7AAdXVzjRAAAAAElFTkSuQmCC',
      '16x6': {
        large:
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAGCAQAAABgddZsAAAAD0lEQVR42mNkIAAYh4ICAAN7AAdXVzjRAAAAAElFTkSuQmCC',
      },
    },
  };
  const mobileImageWithFallBackFeature = {
    value: {
      src:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAQAAACRI2S5AAAAEElEQVR42mNkIAAYRxWAAQAG9gAKqv6+AwAAAABJRU5ErkJggg==',
      '16x9': {
        large:
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAQAAACRI2S5AAAAEElEQVR42mNkIAAYRxWAAQAG9gAKqv6+AwAAAABJRU5ErkJggg==',
        small:
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAQAAACRI2S5AAAAEElEQVR42mNkIAAYRxWAAQAG9gAKqv6+AwAAAABJRU5ErkJggg==',
        small2x:
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAQAAACRI2S5AAAAEElEQVR42mNkIAAYRxWAAQAG9gAKqv6+AwAAAABJRU5ErkJggg==',
      },
    },
  };
  if (flexiVisualCta && flexiVisualCta.value) {
    flexiVisualCta.value.text = flexiVisualCtaText;
  } else {
    flexiVisualCta = { value: { text: flexiVisualCtaText } };
  }

  const iconSrc =
    flexiVisualIconType &&
    flexiVisualIconType.value &&
    flexiVisualIconType.value.src;
  const classes = useStyles();
  const youTubeVideoHref =
    flexiVisualVideoYoutube &&
    flexiVisualVideoYoutube.value &&
    flexiVisualVideoYoutube.value.href;
  const youkuVideoHref =
    flexiVisualVideoYouku &&
    flexiVisualVideoYouku.value &&
    flexiVisualVideoYouku.value.href;

  const getAnalyticsCTAData = () => {
    if (!flexiVisualCtaText) return '';
    if (
      flexiVisualCtaText &&
      flexiVisualComponentHeading &&
      flexiVisualComponentHeading.value
    ) {
      return `${flexiVisualComponentHeading.value} - ${flexiVisualCtaText}`;
    } else if (
      flexiVisualCtaText &&
      !(flexiVisualComponentHeading && flexiVisualComponentHeading.value)
    ) {
      return flexiVisualCtaText;
    }
  };

  const getAnalyticsVideoData = () => {
    if (
      flexiVisualComponentHeading &&
      flexiVisualComponentHeading.value &&
      flexiVisualTitle &&
      flexiVisualTitle.value
    ) {
      return `${flexiVisualComponentHeading.value} - ${flexiVisualTitle.value}`;
    } else if (
      !(flexiVisualComponentHeading && flexiVisualComponentHeading.value) &&
      flexiVisualTitle &&
      flexiVisualTitle.value
    ) {
      return flexiVisualTitle.value;
    } else if (
      flexiVisualComponentHeading &&
      flexiVisualComponentHeading.value &&
      !(flexiVisualTitle && flexiVisualTitle.value)
    ) {
      return flexiVisualComponentHeading.value;
    } else {
      return '';
    }
  };

  const addAnalyticsInfo = (isVideoClicked = false) => {
    const seoCtaText = get(SEOEnglishCTA, 'value', '');
    let obj;
    if (isVideoClicked) {
      obj = {
        ...analyticsData.pageBodyInteraction.galleryVideoClick,
        ...{
          label: seoCtaText,
        },
      };
    } else {
      obj = {
        ...analyticsData.pageBodyInteraction.arrowClick,
        ...{
          label: seoCtaText,
        },
      };
    }
    pushAnaylyticsData(obj);
  };

  const setIsVisible = isVisible => {
    setVisibleState(isVisible);
  };

  const setOverlayOpen = () => {
    addAnalyticsInfo(true);
    setVisibleState(true);
  };
  let playerDOMRef = null;
  const setPlayerDOMRef = ref => {
    playerDOMRef = ref;
  };
  React.useEffect(() => {
    if (!isInsideChina(props.sitecoreContext) && canUseDOM) {
      plyrVideo({
        playerDOMRef: playerDOMRef,
        shouldShowPoster: true,
        handleOpenState: false,
      });
    }
  }, [isInsideChina(props.sitecoreContext)]);
  const renderTile = (image, video, ratio = '16x6') => {
    return (
      <>
        {(get(video, 'value.href') || '').length > 0 ? (
          isInsideChina(props.sitecoreContext) ? (
            <YoukuPlayer
              {...{
                media: {
                  image: get(image, 'value.src', '')
                    ? image
                    : desktopImageWithFallBackFeature,
                  aspectRatio: aspectRatios[ratio],
                },
                sitecoreContext: props.sitecoreContext,
                youkuVideo: video,
                fallbackImage: image,
                pageName: getPageName(props),
                componentName: getComponentName(props),
                analyticsLabelData: getAnalyticsVideoData(),
                alternateAltText: flexiVisualTitle && flexiVisualTitle.value,
              }}
            ></YoukuPlayer>
          ) : (
            <CustomVideo
              video={video}
              posterImage={
                get(image, 'value.src', '')
                  ? image
                  : {
                      ...desktopImageWithFallBackFeature,
                      value: {
                        ...desktopImageWithFallBackFeature.value,
                        [ratio]: {
                          large: getThumbnailFromYoutube(video.value.href),
                        },
                      },
                    }
              }
              aspectRatio={aspectRatios[ratio]}
              setPlayerDOMRef={setPlayerDOMRef}
              alternateAltText={flexiVisualTitle && flexiVisualTitle.value}
            />
          )
        ) : get(image, 'value.src', '') ? (
          <Picture
            media={{
              image,
              aspectRatio: aspectRatios[ratio],
              disableLazyLoad: true,
            }}
            alternateAltText={flexiVisualTitle && flexiVisualTitle.value}
          />
        ) : (
          <Picture
            media={{
              image: desktopImageWithFallBackFeature,
              aspectRatio: aspectRatios[ratio],
              disableLazyLoad: true,
            }}
            alternateAltText={flexiVisualTitle && flexiVisualTitle.value}
          />
        )}
      </>
    );
  };

  const embedGoogleIframe = () => {
    return {
      __html: decodeHTML(`<iframe width="100%" height=${canUseDOM &&
        (isMobile
          ? window.innerHeight - 100
          : window.innerHeight - window.innerHeight * 0.25)} frameborder="0"
        src=${google360IframeSrc} allowfullscreen>
      </iframe>`),
    };
  };

  const getStreetViewOverlay = () => {
    if (canUseDOM) {
      // This is to hide fix header to avoid unwanted overlapping with map heading
      var headerElement = document.querySelector('.MuiAppBar-positionFixed');
      if (
        headerElement &&
        window.getComputedStyle(headerElement).visibility !== 'hidden'
      ) {
        headerElement.style.visibility = 'hidden';
      }
    }
    return (
      <Box className={classes.streetViewOverlay}>
        <div dangerouslySetInnerHTML={embedGoogleIframe()} />
        {location && location.value && (
          <Typography
            component="p"
            variant="body2"
            className={classes.location}
          >
            <Text field={location} />
          </Typography>
        )}
      </Box>
    );
  };

  const isVideoAvailable = () => {
    return (
      (youTubeVideoHref && !isInsideChina(props.sitecoreContext)) ||
      (youkuVideoHref && isInsideChina(props.sitecoreContext))
    );
  };

  const isStreetViewScenario = () => {
    return !isVideoAvailable() && google360IframeSrc;
  };

  //This is a custom function which validate the exit criteria to render the component
  // for china we only need to display youku video, for others either video or google 360
  const shouldComponentRender = () => {
    return isInsideChina(props.sitecoreContext) && !youkuVideoHref
      ? false
      : true;
  };

  const handleCardClickForDifferentScenario = e => {
    e && e.preventDefault();
    if (isStreetViewScenario()) {
      setOverlayOpen();
    } else if (get(flexiVisualCta, 'value.href', '')) {
      if (canUseDOM) {
        window.location.href = flexiVisualCta.value.href;
      }
    }
  };

  return shouldComponentRender() ? (
    <Container
      className={`${classes.root} flexiVisual`}
      data-locator={COMPONENT_NAME}
    >
      <Grid>
        <Box>
          {flexiVisualComponentHeading && flexiVisualComponentHeading.value && (
            <Typography
              variant="h4"
              component="h4"
              className={classes.flexiVisualComponentHeading}
            >
              <Text field={flexiVisualComponentHeading} />
            </Typography>
          )}
          <Link field={flexiVisualCta}>
            <Box
              className={clsx(
                { [classes.contentWrapper]: !isVideoAvailable() },
                { contentWrapper: isVideoAvailable() },
                {
                  [classes.pointerCursor]:
                    (!isStreetViewScenario() &&
                      !get(flexiVisualCta, 'value.href', '')) ||
                    isVideoAvailable(),
                },
                classes.flexiWrapper
              )}
              onClick={e => handleCardClickForDifferentScenario(e)}
            >
              {isVideoAvailable() ? (
                <>
                  {renderTile(
                    flexiVisualImage,
                    isInsideChina(props.sitecoreContext)
                      ? flexiVisualVideoYouku
                      : flexiVisualVideoYoutube
                  )}
                  <Box
                    className={clsx(classes.imageBox, 'imageBox', {
                      videoImageBox: isVideoAvailable(),
                    })}
                  >
                    {flexiVisualTitle && flexiVisualTitle.value && (
                      <Typography
                        variant="h4"
                        component="p"
                        className={classes.labelDescription}
                      >
                        <Text field={flexiVisualTitle} />
                      </Typography>
                    )}
                  </Box>
                </>
              ) : (
                !isInsideChina(props.sitecoreContext) && ( //Google 360 will never be visible for china
                  <>
                    <Picture
                      media={{
                        image: get(flexiVisualImage, 'value.src', '')
                          ? flexiVisualImage
                          : isMobile
                          ? mobileImageWithFallBackFeature
                          : desktopImageWithFallBackFeature,
                        aspectRatio: isMobile
                          ? aspectRatios['16x9']
                          : aspectRatios['16x6'],
                      }}
                      alternateAltText={
                        flexiVisualTitle && flexiVisualTitle.value
                      }
                    />
                    <Box className={classes.imageBox}>
                      {flexiVisualTitle && flexiVisualTitle.value && (
                        <Typography
                          variant="h4"
                          component="p"
                          className={classes.labelDescription}
                        >
                          <Text field={flexiVisualTitle} />
                        </Typography>
                      )}
                      {google360IframeSrc && (
                        <Box className={classes.iconWrapper}>
                          {iconSrc && (
                            <Picture
                              media={{
                                image: flexiVisualIconType,
                                renditionNeeded: false,
                                disableLazyLoad: true,
                                fallbackBackgroundNeeded: false,
                              }}
                              alternateAltText={
                                flexiVisualTitle && flexiVisualTitle.value
                              }
                            />
                          )}

                          {flexiVisualSubText && flexiVisualSubText.value && (
                            <Typography
                              variant="body1Bold"
                              component="p"
                              className={classes.iconText}
                            >
                              <Text field={flexiVisualSubText} />
                            </Typography>
                          )}
                        </Box>
                      )}
                      {flexiVisualCtaText && (
                        <Box className={classes.buttonWrapper}>
                          <hr className={classes.divider} />
                          <Button
                            component="span"
                            buttonType="primary"
                            field={{ value: { text: flexiVisualCtaText } }}
                            hasBorder={false}
                            onClick={() => addAnalyticsInfo()}
                            className={classes.ctaButton}
                          />
                        </Box>
                      )}
                    </Box>
                  </>
                )
              )}
            </Box>
          </Link>
        </Box>
        <Overlay
          title={flexiVisualTitle && flexiVisualTitle.value}
          withButton={false}
          className={`${classes.overlayWrapper} overlay-wrapper`}
          enableClickAway={true}
          isVisible={isOverlayVisible}
          setIsVisible={isVisible => setIsVisible(isVisible)}
          isFlex={isFlexVisual}
        >
          {getStreetViewOverlay()}
        </Overlay>
      </Grid>
    </Container>
  ) : null;
};

export default withErrorBoundary(
  withSitecoreContext()(withNamespaces()(FlexiVisual))
);
